<script lang="ts">
import HtmlText from '../../atoms/HtmlText/HtmlText.svelte';

interface MultiColListProps {
    title?: string;
    headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    titleSize?: string;
    numberOfCols?: number;
    cell?: {
        text: string;
    }[];
    hideBlock?: boolean;
}

let {
    title = '',
    headingLevel = 'h2',
    titleSize = 'h2',
    numberOfCols = 3,
    cell = [],
    hideBlock = false,
}: MultiColListProps = $props();

const titleSizeClassName = $derived(`multi-col-list__title--${titleSize}`);
</script>

{#if !hideBlock}
    <div class="multi-col-list">
        {#if title}
            <svelte:element this={headingLevel} class="multi-col-list__title {titleSizeClassName}">{title}</svelte:element>
        {/if}
        <ul class="multi-col-list__list" style="--number-of-cols: {numberOfCols}">
            {#each cell as item, index}
                <li class="multi-col-list__list-item">
                    <h3 class="multi-col-list__list-item-number">
                        {index < 9 ? 0 : ""}{index + 1}
                    </h3>
                    <HtmlText text={item.text} />
                </li>
            {/each}
        </ul>
    </div>
{/if}

<style lang="scss">
    @use "/src/scss/global-constants/fonts";
    @use "/src/scss/global-constants/typography";
    @use "sass-mq/mq" as *;

    .multi-col-list {
        display: flex;
        flex-direction: column;
        gap: 2.5rem;
        padding-left: var(--layout-pagegrid-margin);
        padding-right: var(--layout-pagegrid-margin);

        @include mq($from: tablet) {
            gap: 5.5rem;
        }

        &__title {
            &--h1   { @include typography.display-xl; }
            &--h1-5 { @include typography.display-hero; }
            &--h2   { @include typography.h2; }
            &--h3   { @include typography.display-md; }
            &--h4   { @include typography.heading-lg; }
            &--h5   { @include typography.heading-md; }
        }

        &__list {
            display: grid;
            gap: 4rem;

            @include mq($from: tablet) {
                grid-template-columns: repeat(var(--number-of-cols), 1fr);
            }
        }

        &__list-item {
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }

        &__list-item-number {
            font-size: var(--text-display-md);

            @include mq($from: tablet) {
                font-size: var(--text-display-md-desktop);
            }
        }
    }
</style>
